import {
  searchableComputedProperty,
  payloadComputedProperty,
  SB,
} from '@play-co/replicant';
import type { State } from '../State';
import {
  buddiesIsEnabled,
  buddiesGetEvent,
  buddiesIsAvailable,
  buddiesIsPartyFull,
} from './buddies.getters';

export const buddiesProperties = {
  /**
   * Whether Baking Buddies is enabled for this player (AB test bucket).
   */
  buddiesEnabled: searchableComputedProperty(
    SB.boolean(),
    (state: State) => !!buddiesIsEnabled(state),
  ),

  /**
   * Current party size (1 = solo, up to 4).
   * Returns 1 when no event exists (solo by default).
   * Used to filter players with free slots in search.
   */
  buddiesPartySize: searchableComputedProperty(
    SB.number(),
    (state: State, api) => {
      const event = buddiesGetEvent(state, api.date.now());
      if (!event) return 1;
      return 1 + Object.keys(event.party).length;
    },
  ),

  /**
   * Number of pending received invites.
   * Used to filter out players with too many pending invites (>= 10).
   */
  buddiesPendingInviteCount: searchableComputedProperty(
    SB.number(),
    (state: State, api) => {
      const event = buddiesGetEvent(state, api.date.now());
      if (!event) return 0;
      return Object.values(event.invites).filter(
        (i) => i.status === 'inviteReceived',
      ).length;
    },
  ),

  /**
   * Whether this player can receive an invite OA notification.
   * Not searchable — only used as a payload field in search results.
   */
  buddiesCanReceiveInviteOA: payloadComputedProperty(
    SB.boolean(),
    (state: State, api) => {
      const now = api.date.now();
      if (!buddiesIsAvailable(state, now)) return false;
      if (buddiesIsPartyFull(state, now)) return false;
      return true;
    },
  ),
};
